import AffiliateForm from "modules/storyblok/components/AffiliateForm";
import RegistrationForm from "modules/legal-partners/components/RegistrationForm";
import { AhPlus } from "../../components/Modals";
import type { Modals, RUICButtonSizes, RUICButtonVariants, SBButtonSizes, SBButtonVariants } from "./Button.d";

const modals: Record<Modals, JSX.Element> = {
  "legal-partners": <RegistrationForm />,
  "airhelp-plus": <AhPlus />,
  affiliate: <AffiliateForm />,
};

const sizes: Record<SBButtonSizes, RUICButtonSizes> = {
  lg: "l",
  md: "m",
  sm: "s",
  xs: "xs",
};

const variants: Record<SBButtonVariants, RUICButtonVariants> = {
  primary: "primary",
  secondary: "secondary",
  tertiary: "primaryAlt",
  subtle: "subtle",
  unstyled: "unstyled",
  link: "link",
  linkPrimary: "link",
  linkSecondary: "link",
  danger: "danger",
};

export { modals, sizes, variants };
